import { useState } from 'preact/hooks';

import { OverviewPanel } from './OverviewPanel';
import { InsightsPanel } from './InsightsPanel';
import { AnomaliesPanel } from './AnomaliesPanel';
import { RecommendationsPanel } from './RecommendationsPanel';
import { HealthPanel } from './HealthPanel';
import { ToolUsagePanel } from './ToolUsagePanel';
import { LLMCostsPanel } from './LLMCostsPanel';
import { AuditPanel } from './AuditPanel';
import { QueryBuilderPanel } from './QueryBuilderPanel';
import { SettingsPanel } from './SettingsPanel';
import { Button } from '../../components/ui';

const TABS = [
 { key: 'overview', label: 'Overview', icon: '' },
 { key: 'insights', label: 'Insights', icon: '' },
 { key: 'anomalies', label: 'Anomalias', icon: '' },
 { key: 'recommendations', label: 'Recomendações', icon: '' },
 { key: 'health', label: 'Health', icon: '' },
 { key: 'tool-usage', label: 'Uso Ferramentas', icon: '' },
 { key: 'llm-costs', label: 'Custos LLM', icon: '' },
 { key: 'audit', label: 'Auditoria', icon: '' },
 { key: 'query', label: 'Query Builder', icon: '' },
 { key: 'settings', label: 'Configurações', icon: '' },
] as const;

type TabKey = typeof TABS[number]['key'];

const PANELS: Record<TabKey, () => any> = {
  'overview': OverviewPanel,
  'insights': InsightsPanel,
  'anomalies': AnomaliesPanel,
  'recommendations': RecommendationsPanel,
  'health': HealthPanel,
  'tool-usage': ToolUsagePanel,
  'llm-costs': LLMCostsPanel,
  'audit': AuditPanel,
  'query': QueryBuilderPanel,
  'settings': SettingsPanel,
};

interface IntelligenceLayoutProps {
  path?: string;
  rest?: string;
}

export function IntelligenceLayout(_props: IntelligenceLayoutProps) {
  const [activeTab, setActiveTab] = useState<TabKey>('overview');
  const [mobileNav, setMobileNav] = useState(false);

  const ActivePanel = PANELS[activeTab];

  return (
    <div class="min-h-screen bg-gray-950 text-gray-100">
      {/* Header */}
      <div class="border-b border-gray-800 bg-gray-900/80 backdrop-blur-sm sticky top-0 z-20">
        <div class="max-w-[1600px] mx-auto px-4 py-3 flex items-center justify-between">
          <div class="flex items-center gap-3">
 <span class="text-xl"></span>
            <h1 class="text-lg font-bold text-white">Intelligence Layer</h1>
          </div>
          <Button variant="ghost"
            class="lg:hidden p-2 rounded-lg bg-gray-800 text-gray-300"
            onClick={() => setMobileNav(!mobileNav)}
          >
 
          </Button>
        </div>
      </div>

      <div class="max-w-[1600px] mx-auto flex">
        {/* Sidebar nav */}
        <nav class={`${mobileNav ? 'block' : 'hidden'} lg:block w-56 shrink-0 border-r border-gray-800 bg-gray-900/50 min-h-[calc(100vh-57px)] sticky top-[57px] overflow-y-auto`}>
          <div class="py-3">
            {TABS.map((tab) => {
              const active = activeTab === tab.key;
              return (
                <Button variant="ghost"
                  key={tab.key}
                  class={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm transition-colors text-left ${
                    active
                      ? 'bg-indigo-600/20 text-indigo-300 border-r-2 border-indigo-500 font-medium'
                      : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800/50'
                  }`}
                  onClick={() => { setActiveTab(tab.key); setMobileNav(false); }}
                >
                  <span class="text-base">{tab.icon}</span>
                  <span>{tab.label}</span>
                </Button>
              );
            })}
          </div>
        </nav>

        {/* Content */}
        <div class="flex-1 min-w-0 p-4 lg:p-6">
          <ActivePanel />
        </div>
      </div>
    </div>
  );
}
